/* =====================================================================
   Nuvò · Refresh del sito — comportamenti comuni a tutte le pagine
   Approvato il 19/10/2026. Lettere e numeri nei commenti = lista approvata.
   Legge i dati da <script id="nv-data"> (sezione nuvo-refresh).
   ===================================================================== */
(function () {
  'use strict';
  if (window.__nuvoRefresh) { return; }
  window.__nuvoRefresh = true;

  var reduced = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var D = { products: {}, articles: {}, labels: {}, menu: null };
  function readData() {
    var el = document.getElementById('nv-data');
    if (!el) { return; }
    try { D = JSON.parse(el.textContent); } catch (e) { if (window.console) { console.warn('Nuvò refresh: dati non leggibili', e); } }
    D.products = D.products || {}; D.articles = D.articles || {}; D.labels = D.labels || {};
    var ak = {}; Object.keys(D.articles).forEach(function (k) { ak[pathOf(k)] = D.articles[k]; }); D.articles = ak;
  }
  function L(k, fb) { return (D.labels && D.labels[k]) || fb; }
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) { e.className = cls; } if (text != null) { e.textContent = text; } return e; }
  function handleOf(href) {
    if (!href) { return ''; }
    var m = String(href).match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }
  function pathOf(href) {
    try { var u = new URL(href, window.location.href); return u.pathname.replace(/^\/(en|fr|it)(?=\/)/, '').replace(/\/$/, '') || '/'; } catch (e) { return ''; }
  }

  var CARD = '.nh-pc,.nc-pc,.na-card,.npdp-pc';
  var IMG = '.nh-pc__img,.nc-pc__media,.nc-pc__img,.na-card-img,.npdp-pc__media';
  var NAME = '.nh-pc__name,.nc-pc__name,.na-h3,.npdp-pc__name';
  var FOOT = '.nh-pc__foot,.nc-pc__row,.nc-pc__foot,.na-foot,.npdp-pc__row';

  /* ---------- 4 · H · K · card prodotto ---------- */
  function stars(r) { var n = Math.max(0, Math.min(5, Math.round(Number(r) || 0))); return '★★★★★'.slice(0, n) + '☆☆☆☆☆'.slice(0, 5 - n); }
  function enhanceCard(card) {
    if (card.dataset.nvCard) { return; }
    var a = card.querySelector('a[href*="/products/"]');
    var h = a ? handleOf(a.getAttribute('href')) : '';
    var p = h && D.products[h];
    card.dataset.nvCard = h || '-';
    if (!p) { return; }
    var img = card.querySelector(IMG), name = card.querySelector(NAME), foot = card.querySelector(FOOT);

    // 4 · esigenza sotto il nome
    if (p.per && name && !card.querySelector('.nv-per')) {
      var per = el('p', 'nv-per', L('per', 'Per:') + ' ' + p.per);
      name.insertAdjacentElement('afterend', per);
    }
    // 4 · stelle e numero di recensioni
    if (p.rc && Number(p.rc) > 0 && !card.querySelector('.nv-rate')) {
      var rate = el('p', 'nv-rate');
      var s = el('span', 'nv-rate__s', stars(p.r)); s.setAttribute('aria-hidden', 'true');
      var t = el('span', null, '(' + p.rc + ') ' + L('reviews', 'recensioni'));
      rate.appendChild(s); rate.appendChild(t);
      rate.setAttribute('aria-label', String(p.r || '').replace('.', ',') + ' su 5, ' + p.rc + ' ' + L('reviews', 'recensioni'));
      if (foot) { foot.insertAdjacentElement('beforebegin', rate); } else { card.appendChild(rate); }
    }
    // H · Pack, Texture, Card (foto scelte a mano nei metafield)
    var views = [['pack', p.pack, L('pack', 'Pack')], ['tex', p.tex, L('tex', 'Texture')], ['card', p.card, L('card', 'Card')]];
    var have = views.filter(function (v) { return !!v[1]; });
    if (img && (have.length >= 2 || (have.length >= 1 && !p.pack))) {
      card.classList.add('nv-has-views');
      if (getComputedStyle(img).position === 'static') { img.style.position = 'relative'; }
      var box = el('span', 'nv-views'); box.setAttribute('aria-hidden', 'true');
      var tabs = el('div', 'nv-tabs'); tabs.setAttribute('role', 'group'); tabs.setAttribute('aria-label', L('views', 'Immagine della card'));
      views.forEach(function (v, k) {
        if (k > 0 && !v[1]) { return; }
        if (v[1]) { var im = el('img'); im.src = v[1]; im.alt = ''; im.loading = 'lazy'; im.dataset.v = v[0]; if (k === 0) { im.classList.add('is-on'); } box.appendChild(im); }
        var b = el('button', null, v[2]); b.type = 'button'; b.dataset.v = v[0]; b.setAttribute('aria-pressed', k === 0 ? 'true' : 'false');
        tabs.appendChild(b);
      });
      img.appendChild(box);
      img.insertAdjacentElement('afterend', tabs);
      tabs.addEventListener('click', function (e) {
        var b = e.target.closest('button'); if (!b) { return; }
        e.preventDefault();
        $$('button', tabs).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        $$('img', box).forEach(function (im) { im.classList.toggle('is-on', im.dataset.v === b.dataset.v); });
      });
    }
    // K · Confronta
    if (D.compare && p.cmp && img && !card.querySelector('.nv-cmp-chk')) {
      card.classList.add('nv-card-rel');
      var lab = el('label', 'nv-cmp-chk');
      var cb = el('input'); cb.type = 'checkbox'; cb.className = 'nv-cmp-in'; cb.value = h;
      lab.appendChild(cb); lab.appendChild(document.createTextNode(' ' + L('cmp', 'Confronta')));
      card.insertBefore(lab, card.firstChild);
      cb.checked = cmpSel.indexOf(h) >= 0;
    }
  }

  /* ---------- 6 · blog: argomento e minuti di lettura ---------- */
  function enhancePosts(root) {
    var min = L('min', 'min di lettura');
    $$('.nh-post,.nb-feat', root).forEach(function (post) {
      if (post.dataset.nvPost) { return; }
      post.dataset.nvPost = '1';
      var a = post.querySelector('a[href*="/blogs/"]');
      var d = a && D.articles[pathOf(a.href)];
      var date = post.querySelector('.nh-post__date');
      if (!d || !date) { return; }
      var hasTag = !!post.querySelector('.nb-tag,.ns-tag');
      date.textContent = (hasTag || !d.t ? '' : d.t + ' · ') + d.m + ' ' + min;
      date.classList.add('nv-rt');
    });
    var cur = D.current_article;
    var hd = cur && $('.nb-hero__card .nh-post__date');
    if (hd && !hd.dataset.nvPost) { hd.dataset.nvPost = '1'; hd.textContent = hd.textContent + ' · ' + cur.m + ' ' + min; }
  }

  /* ---------- I · attivi da esplorare ---------- */
  function initExplorer(box) {
    if (box.dataset.nvReady) { return; }
    box.dataset.nvReady = '1';
    var tabs = $$('[role="tab"]', box), panels = $$('[role="tabpanel"]', box);
    function show(i, focus) {
      tabs.forEach(function (t, k) { t.setAttribute('aria-selected', String(k === i)); t.tabIndex = k === i ? 0 : -1; });
      panels.forEach(function (p, k) { p.hidden = k !== i; p.classList.toggle('is-in', k === i && !reduced.matches); });
      if (focus) { tabs[i].focus(); }
    }
    tabs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    box.addEventListener('keydown', function (e) {
      var k = tabs.indexOf(document.activeElement); if (k < 0) { return; }
      if (e.key === 'ArrowRight') { e.preventDefault(); show((k + 1) % tabs.length, true); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); show((k - 1 + tabs.length) % tabs.length, true); }
    });
  }

  /* ---------- FAQ: domande sempre visibili (il «+» senape è nascosto dal CSS) ---------- */
  function openFaqs(root) {
    $$('.na-faq', root).forEach(function (f) { f.classList.add('is-open'); $$('.na-faq-list', f).forEach(function (l) { l.hidden = false; }); });
    $$('[data-nc-faq-list],[data-nh-faq] [data-list]', root).forEach(function (l) { l.hidden = false; });
  }

  /* ---------- T · newsletter ---------- */
  function enhanceNewsletter(root) {
    $$('.nh-nl form,.npdp-az form', root).forEach(function (f) {
      if (f.dataset.nvNl) { return; }
      f.dataset.nvNl = '1';
      var input = f.querySelector('input[type="email"]');
      if (input && !input.closest('.nv-fl')) {
        var lab = input.id ? f.querySelector('label[for="' + input.id + '"]') : null;
        var text = (lab && lab.textContent.trim()) || input.getAttribute('placeholder') || 'Email';
        var wrap = el('span', 'nv-fl');
        input.parentNode.insertBefore(wrap, input);
        wrap.appendChild(input);
        var fl = el('span', 'nv-fl__l', text); fl.setAttribute('aria-hidden', 'true');
        wrap.appendChild(fl);
        if (!input.getAttribute('placeholder')) { input.setAttribute('placeholder', ' '); }
        if (lab) { lab.classList.add('nv-moved'); input.setAttribute('aria-label', text); }
      }
      f.addEventListener('submit', function () { var b = f.querySelector('[type="submit"]'); if (b) { b.classList.add('nv-sending'); } });
    });
    $$('.nh-nl__msg[role="status"],.npdp-az__msg[role="status"]', root).forEach(function (m) {
      if (m.dataset.nvOk) { return; }
      m.dataset.nvOk = '1';
      var span = el('span', 'nv-ok');
      span.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5 9-10"/></svg>';
      while (m.firstChild) { span.appendChild(m.firstChild); }
      m.appendChild(span);
    });
  }

  /* ---------- A · fascia video: pausa e movimento ridotto ---------- */
  function initBand(sec) {
    if (sec.dataset.nvReady) { return; }
    sec.dataset.nvReady = '1';
    var v = sec.querySelector('video'), b = sec.querySelector('.nvtb__pause');
    if (!v) { if (b) { b.hidden = true; } return; }
    v.muted = true; v.setAttribute('playsinline', '');
    function set(play) { if (play) { var pr = v.play(); if (pr && pr.catch) { pr.catch(function () {}); } } else { v.pause(); } if (b) { b.textContent = play ? L('pause', 'Pausa') : L('play', 'Riprendi'); b.setAttribute('aria-pressed', String(!play)); } }
    set(!reduced.matches);
    if (b) { b.addEventListener('click', function () { set(v.paused); }); }
  }

  /* ---------- E · transizione card → scheda ---------- */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) { return; }
    var a = e.target.closest && e.target.closest('a[href*="/products/"]');
    if (!a) { return; }
    var card = a.closest(CARD); if (!card) { return; }
    var img = card.querySelector(IMG); if (!img) { return; }
    $$('.npdp-gal__stage').forEach(function (s) { s.style.viewTransitionName = 'none'; });
    $$('[data-nv-vt]').forEach(function (x) { x.style.viewTransitionName = ''; x.removeAttribute('data-nv-vt'); });
    img.style.viewTransitionName = 'nv-prod';
    img.setAttribute('data-nv-vt', '');
  });
  window.addEventListener('pageshow', function () {
    $$('[data-nv-vt]').forEach(function (x) { x.style.viewTransitionName = ''; x.removeAttribute('data-nv-vt'); });
    $$('.npdp-gal__stage').forEach(function (s) { s.style.viewTransitionName = ''; });
  });

  /* ---------- N · conferma «Aggiunto» · F · carrello laterale ---------- */
  var ADD = '[data-nh-add],[data-nc-act="add"],[data-nb-add],.npdp-add,[data-nc-add] button,form[action*="/cart/add"] button:not([type="button"]),form[action*="/cart/add"] [type="submit"]';
  var lastBtn = null, lastAt = 0, delayNext = false;
  function ndRoot() { return document.querySelector('[data-nd-root]'); }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest(ADD);
    if (!b || b.disabled || b.closest('[data-nh-test]')) { return; }
    lastBtn = b; lastAt = Date.now();
    var r = ndRoot();
    delayNext = !!(r && r.getAttribute('data-nd-auto') === 'true' && !/\/cart\/?$/.test(location.pathname) && !b.closest('[data-nd-root]') && !reduced.matches);
  }, true);
  function markAdded() {
    if (!lastBtn || Date.now() - lastAt > 6000) { return; }
    var b = lastBtn; lastBtn = null;
    if (b.closest('[data-nd-root]')) { return; }
    var orig = b.innerHTML;
    b.classList.add('nv-added');
    b.textContent = L('added', 'Aggiunto');
    setTimeout(function () { b.classList.remove('nv-added'); if (b.textContent === L('added', 'Aggiunto')) { b.innerHTML = orig; } }, 1600);
  }
  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var pr = _fetch.apply(this, arguments);
      if (/\/cart\/add(\.js|\.json)?(\?|$)/.test(String(url).split('#')[0])) { pr.then(function (res) { if (res && res.ok) { markAdded(); } }).catch(function () {}); }
      return pr;
    };
  }
  ['nuvo:cart:added', 'nuvo:cart:updated', 'cart:refresh', 'cart:updated'].forEach(function (ev) { document.addEventListener(ev, markAdded); });

  // F · barra della spedizione gratuita che si riempie + apertura del carrello dopo la conferma
  var lastW = '0%';
  function animateBar(fromZero) {
    var r = ndRoot(); var span = r && r.querySelector('.nd-ship__bar span');
    if (!span || reduced.matches) { if (span) { lastW = span.style.width; } return; }
    var target = span.style.width || '0%';
    span.style.transition = 'none';
    span.style.width = fromZero ? '0%' : lastW;
    void span.offsetWidth;
    span.style.transition = '';
    requestAnimationFrame(function () { requestAnimationFrame(function () { span.style.width = target; }); });
    lastW = target;
  }
  function watchDrawer() {
    var r = ndRoot();
    if (!r || r.dataset.nvWatch || !window.MutationObserver) { return; }
    r.dataset.nvWatch = '1';
    var wasOpen = r.classList.contains('is-open');
    new MutationObserver(function () {
      var open = r.classList.contains('is-open');
      if (open && !wasOpen) {
        if (delayNext) {
          delayNext = false;
          r.classList.remove('is-open'); r.setAttribute('aria-hidden', 'true');
          wasOpen = false;
          setTimeout(function () {
            r.classList.add('is-open'); r.setAttribute('aria-hidden', 'false');
            document.documentElement.style.overflow = 'hidden';
            var x = r.querySelector('.nd__x'); if (x) { x.focus(); }
          }, 650);
          return;
        }
        animateBar(true);
      }
      wasOpen = open;
    }).observe(r, { attributes: true, attributeFilter: ['class'] });
    var inner = r.querySelector('[data-nd-inner]');
    if (inner) {
      new MutationObserver(function () { if (r.classList.contains('is-open')) { animateBar(false); } else { var s = r.querySelector('.nd-ship__bar span'); if (s) { lastW = s.style.width; } } })
        .observe(inner, { childList: true });
    }
  }

  // F · «Aggiungi» del prodotto abbinato nel carrello laterale
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-nv-abb]');
    if (!b || b.disabled) { return; }
    e.preventDefault();
    b.disabled = true;
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var r = ndRoot();
    window.fetch(base + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(b.getAttribute('data-nv-abb')), quantity: 1 }] })
    }).then(function (res) {
      if (!res.ok) { throw new Error('cart'); }
      // con l'apertura automatica accesa il carrello si aggiorna da solo; altrimenti lo aggiorniamo noi
      if (!(r && r.getAttribute('data-nd-auto') === 'true') && window.NuvoDrawer) { window.NuvoDrawer.refresh(); }
    }).catch(function () { b.disabled = false; });
  });

  /* ---------- K · confronta ---------- */
  var cmpSel = [];
  function cmpRender() {
    var tray = $('#nv-cmp-tray'); if (!tray) { return; }
    tray.hidden = cmpSel.length === 0;
    document.documentElement.classList.toggle('nv-has-tray', cmpSel.length > 0);
    var items = $('#nv-cmp-items', tray); items.textContent = '';
    cmpSel.forEach(function (h) { var p = D.products[h]; items.appendChild(el('span', null, (p && (p.n || p.t)) || h)); });
    if (cmpSel.length < 2) { items.appendChild(el('span', 'nv-cmp-tray__hint', L('cmp_hint', 'Scegli almeno un altro prodotto'))); }
    var go = $('#nv-cmp-go', tray); go.disabled = cmpSel.length < 2; go.textContent = L('cmp_btn', 'Confronta') + ' (' + cmpSel.length + ')';
    $$('.nv-cmp-in').forEach(function (c) { c.checked = cmpSel.indexOf(c.value) >= 0; });
  }
  document.addEventListener('change', function (e) {
    if (!e.target.classList || !e.target.classList.contains('nv-cmp-in')) { return; }
    var h = e.target.value, i = cmpSel.indexOf(h);
    if (e.target.checked && i < 0) { if (cmpSel.length >= 3) { e.target.checked = false; return; } cmpSel.push(h); }
    if (!e.target.checked && i >= 0) { cmpSel.splice(i, 1); }
    cmpRender();
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.nv-cmp-chk')) { e.stopPropagation(); }
  }, true);
  function initCompare() {
    var tray = $('#nv-cmp-tray'), dlg = $('#nv-cmp-dlg');
    if (!tray || !dlg || tray.dataset.nvReady) { return; }
    tray.dataset.nvReady = '1';
    document.body.appendChild(tray); document.body.appendChild(dlg);
    $('#nv-cmp-clear').addEventListener('click', function () { cmpSel = []; cmpRender(); });
    $('#nv-cmp-go').addEventListener('click', function () {
      if (cmpSel.length < 2) { return; }
      var rows = D.compare_rows || [];
      var tbl = $('#nv-cmp-tbl'); tbl.textContent = '';
      var thead = el('thead'), tr = el('tr'); tr.appendChild(el('th'));
      cmpSel.forEach(function (h) { var p = D.products[h] || {}; var th = el('th'); th.scope = 'col'; var a = el('a', null, p.n || p.t || h); a.href = p.u || ('/products/' + h); th.appendChild(a); tr.appendChild(th); });
      thead.appendChild(tr); tbl.appendChild(thead);
      var tb = el('tbody');
      rows.forEach(function (r, k) {
        var row = el('tr'); var th = el('th', null, r); th.scope = 'row'; row.appendChild(th);
        cmpSel.forEach(function (h) { var p = D.products[h] || {}; row.appendChild(el('td', null, (p.cmp && p.cmp[k]) || '—')); });
        tb.appendChild(row);
      });
      tbl.appendChild(tb);
      if (dlg.showModal) { dlg.showModal(); } else { dlg.setAttribute('open', ''); }
    });
    $('#nv-cmp-x').addEventListener('click', function () { if (dlg.close) { dlg.close(); } else { dlg.removeAttribute('open'); } });
    dlg.addEventListener('click', function (e) { if (e.target === dlg && dlg.close) { dlg.close(); } });
  }

  /* ---------- G · barra annunci: pulsante pausa ---------- */
  function initAnnouncement() {
    var bar = $('slideshow-component.announcement-bar');
    if (!bar || bar.dataset.nvReady || $$('.slideshow__slide', bar).length < 2) { return; }
    if (typeof bar.pause !== 'function' || typeof bar.play !== 'function') { return; }
    bar.dataset.nvReady = '1';
    var b = el('button', 'nvtb__pause', L('pause', 'Pausa')); b.type = 'button'; b.setAttribute('aria-pressed', 'false');
    b.style.top = '50%'; b.style.transform = 'translateY(-50%)'; b.style.right = '56px';
    var paused = false;
    function set(p) { paused = p; try { if (p) { bar.pause(); } else { bar.play(); } } catch (e) {} b.textContent = p ? L('play', 'Riprendi') : L('pause', 'Pausa'); b.setAttribute('aria-pressed', String(p)); }
    b.addEventListener('click', function () { set(!paused); });
    bar.appendChild(b);
    if (reduced.matches) { set(true); }
  }

  /* ---------- L · aiuto · S · torna su ---------- */
  function initHelp() {
    var hp = $('#nv-hp'); if (!hp || hp.dataset.nvReady) { return; }
    hp.dataset.nvReady = '1'; document.body.appendChild(hp);
    var b = $('#nv-hp-btn'), p = $('#nv-hp-p');
    function set(o) { p.hidden = !o; b.setAttribute('aria-expanded', String(o)); document.documentElement.classList.toggle('nv-hp-open', o); }
    b.addEventListener('click', function () { set(p.hidden); });
    document.addEventListener('click', function (e) { if (!hp.contains(e.target)) { set(false); } });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !p.hidden) { set(false); b.focus(); } });
  }
  function initTop() {
    var tt = $('#nv-tt'); if (!tt || tt.dataset.nvReady) { return; }
    tt.dataset.nvReady = '1'; document.body.appendChild(tt);
    var ring = $('#nv-tt-ring'), tk = false;
    function on() {
      var y = window.scrollY, max = document.documentElement.scrollHeight - window.innerHeight;
      ring.style.strokeDashoffset = String(132 - 132 * (max > 0 ? Math.min(1, y / max) : 0));
      tt.classList.toggle('is-on', y > 700); tk = false;
    }
    window.addEventListener('scroll', function () { if (!tk) { tk = true; requestAnimationFrame(on); } }, { passive: true });
    tt.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduced.matches ? 'auto' : 'smooth' }); });
    on();
  }

  /* ---------- link allo skin test: blocco intero visibile sotto l'header ---------- */
  function hdrOffset() {
    var h = 0;
    $$('#shopify-section-header,.shopify-section-header,#shopify-section-mobile-header,#shopify-section-announcement-bar').forEach(function (x) {
      var cs = getComputedStyle(x), r = x.getBoundingClientRect();
      var stuck = /sticky|fixed/.test(cs.position) || $$('*', x).some(function (c) { return /sticky|fixed/.test(getComputedStyle(c).position) && c.offsetHeight > 30; });
      if (stuck && r.height > 0 && r.bottom > 0) { h = Math.max(h, r.bottom); }
    });
    if (!h) { var hd = document.getElementById('shopify-section-header'); h = hd ? hd.offsetHeight : 120; }
    document.documentElement.style.setProperty('--nv-hdr', Math.round(h + 16) + 'px');
    return h + 16;
  }
  function goTo(id, smooth) {
    var t = document.getElementById(id); if (!t) { return false; }
    // l'inizio della sezione si ferma esattamente sotto l'header
    var y = t.getBoundingClientRect().top + window.pageYOffset - (hdrOffset() - 16);
    window.scrollTo({ top: Math.max(0, y), behavior: smooth && !reduced.matches ? 'smooth' : 'auto' });
    return true;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="#skin-test"]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) { return; }
    var u; try { u = new URL(a.href, location.href); } catch (err) { return; }
    if (u.pathname.replace(/\/$/, '') !== location.pathname.replace(/\/$/, '') || !document.getElementById('skin-test')) { return; }
    e.preventDefault(); e.stopPropagation();
    if (window.history && history.replaceState) { history.replaceState(null, '', '#skin-test'); }
    goTo('skin-test', true);
    var hp = $('#nv-hp-p'); if (hp && !hp.hidden) { $('#nv-hp-btn').click(); }
  }, true);
  if (location.hash === '#skin-test') {
    window.addEventListener('load', function () { goTo('skin-test', false); setTimeout(function () { goTo('skin-test', false); }, 400); setTimeout(function () { goTo('skin-test', false); }, 1100); });
  }

  /* ---------- avvio ---------- */
  function run(root) {
    root = root || document;
    $$(CARD, root).forEach(enhanceCard);
    enhancePosts(root);
    $$('[data-nvx]', root).forEach(initExplorer);
    $$('.nvtb', root).forEach(initBand);
    openFaqs(root);
    enhanceNewsletter(root);
  }
  function start() {
    readData();
    initCompare(); initHelp(); initTop(); initAnnouncement(); watchDrawer();
    run(document);
    cmpRender();
    if (window.MutationObserver) {
      var pending = false;
      new MutationObserver(function (list) {
        if (pending) { return; }
        for (var i = 0; i < list.length; i++) {
          if (list[i].addedNodes.length) { pending = true; break; }
        }
        if (pending) { requestAnimationFrame(function () { pending = false; run(document); }); }
      }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
  document.addEventListener('shopify:section:load', function (e) { readData(); run(e.target); });
})();
